export enum ScrollTypes {
    Previous,
    Current,
    Next
  }
